// extracted by mini-css-extract-plugin
export default {"form-control":"Button_form-control__05XZi","btn":"Button_btn__RxNFY"};